import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";

const FeatureRoute = ({ feature, children }) => {
  const [access, setAccess] = useState(null);

  useEffect(() => {
    let cancelled = false;

    apiClient.get(`/features/${feature}/access`)
      .then(({ data }) => {
        if (!cancelled) setAccess(Boolean(data.has_access));
      })
      .catch(() => {
        if (!cancelled) setAccess(false);
      });

    return () => {
      cancelled = true;
    };
  }, [feature]);

  if (access === null) {
    return (
      <div className="hpa-feature-state">
        <i className="fa-solid fa-spinner fa-spin" aria-hidden="true" />
        <p>Checking your package access…</p>
      </div>
    );
  }

  if (!access) {
    return (
      <div className="hpa-feature-state hpa-feature-locked">
        <div className="hpa-feature-lock-icon">
          <i className="fa-solid fa-lock" aria-hidden="true" />
        </div>
        <span>Package feature</span>
        <h2>BMI &amp; Body Metrics Calculator</h2>
        <p>
          This tool is available with packages that include the BMI Calculator
          feature. Choose an eligible package or ask the academy team to add it
          to your subscription.
        </p>
        <Link to="/libraries" className="btn btn-primary btn-skew">
          <span>Explore Eligible Packages</span>
        </Link>
      </div>
    );
  }

  return children;
};

export default FeatureRoute;
